export const RECORDING_CODEC = "video/webm;codecs=vp8";
export const RECORDING_BPS = 8000000;

